export function logDefaultHttpError(code, url, message) {
  console.error(`received non-ok response code ${code} from ${url}${message ? `, message ${message}` : ""}`);
}